/**
 * 위치정보 취급대장 (/adm/location/gps-log) — 위치정보 조회 기록 목록
 * ($j.Pages.Admin.GpsUseLog / body data-page-name="GpsUseLog")
 */
export default class GpsUseLog {
    initialize() {
        let $table = null;

        $(function () {
            loadTable();
        });

        function loadTable() {
            const columns = [
                {data: 'num', title: '번호', width: '60px'},
                // 회원 표기는 관리자 공용 규약 — `이름#번호` + 회원 팝오버
                {data: null, title: '회원', width: '140px',
                    render: (d, t, r) => $j.F.Admin.Member.Pop.cell(r.mb_no, r.mem_name)},
                {
                    // in_type — MemberGpsService::IN_TYPE_* (1 android · 2 ios). 기록 시점의 기기 플랫폼
                    data: 'in_type', title: '취득경로', width: '120px',
                    render: v => (v == 2 ? 'ios' : 'android')
                },
                {
                    data: null, title: '제공서비스', width: '120px',
                    render: function () { return '위치정보조회'; }
                },
                {data: 'recv_no', title: '제공받는자', width: '120px'},
                {data: 'datetime', title: '날짜', width: '160px', render: v => $j.Common.Util.formatDateTime(v)}
            ];

            if ($table) {
                $table.destroy();
                $('#log-table').empty();
            }

            $table = new DataTable('#log-table', {
                autoWidth: false,
                columns: columns,
                headerCallback: (thead) => $(thead).find('th').css('text-align', 'center'),
                ajax: {
                    url: '/adm/ajax/location/gps-log/list',
                    type: 'post'
                },
                language: {
                    emptyTable: "데이터가 없습니다.",
                    info: "",
                    infoEmpty: "",
                    infoFiltered: "",
                    loadingRecords: "로딩 중...",
                    zeroRecords: "일치하는 결과가 없습니다.",
                    paginate: {
                        previous: "<i class='fa fa-chevron-left'></i>",
                        next: "<i class='fa fa-chevron-right'></i>"
                    }
                },
                processing: true,
                serverSide: true,
                ordering: false,
                pageLength: 25,
                lengthChange: false,
                searching: false
            });
        }

    }
}
